import { getRgObjectsOfType as r, RG_TYPE as l } from "@project-rouge/rg-core";
import { getPolygonArea as f } from "../../../geometry-utils/core/index14.js";
const p = (n) => {
  let t = 0;
  const e = r(n, l.Building);
  for (const g of e) {
    const o = g.data.levels.find((i) => i.levelIndex === 0);
    o != null && o.geaPolygon && (t += f(o.geaPolygon));
  }
  return t;
};
export {
  p as getFootprint
};
//# sourceMappingURL=index21.js.map
